import classNames from 'classnames';

export const cx = classNames;
